//
// This file is AUTO-GENERATED by protoc-gen-ts.
// Do not modify it manually.
///
import api from '../../api'
import * as googleTypes from '../../googleTypes'
import { BillingConfig as arangodb_cloud_billing_v1_BillingConfig } from './billing'
import { CreatePaymentMethodRequest as arangodb_cloud_billing_v1_CreatePaymentMethodRequest } from './billing'
import { Invoice as arangodb_cloud_billing_v1_Invoice } from './billing'
import { PaymentMethod as arangodb_cloud_billing_v1_PaymentMethod } from './billing'
import { ListOptions as arangodb_cloud_common_v1_ListOptions } from '../../common/v1/common'
import { Currency as arangodb_cloud_currency_v1_Currency } from '../../currency/v1/currency'
import { User as arangodb_cloud_iam_v1_User } from '../../iam/v1/iam'
import { EntityDetails as arangodb_cloud_internal_resourcemanager_v1_EntityDetails } from '../../resourcemanager/v1/iresourcemanager'

// File: billing/v1/ibilling.proto
// Package: arangodb.cloud.internal.billing.v1

// AEUDiscount is one entry of the AEU discount history of an organization.
// The discount (agreed in the customer contract) reduces the credits charged for
// the Arango revenue usage kinds (AEU and Dedicated Data Cluster) only;
// infrastructure usage is never discounted.
export interface AEUDiscount {
  // System identifier of the entry.
  // This is a read-only value.
  // string
  id?: string;
  
  // Identifier of the organization the discount applies to.
  // string
  organization_id?: string;
  
  // Discount in percent, from 0 (no discount) to 100 (AEU free of charge).
  // number
  discount_percent?: number;
  
  // Start of the effective window (inclusive). The entry is effective until the
  // starts_at of the next entry of the same organization.
  // googleTypes.Timestamp
  starts_at?: googleTypes.Timestamp;
  
  // Optional human readable description, e.g. the contract reference.
  // string
  description?: string;
  
  // The creation timestamp of the entry.
  // This is a read-only value.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Identifier of the user who created the entry.
  // This is a read-only value.
  // string
  created_by_id?: string;
}

// List of AEUDiscount entries.
export interface AEUDiscountList {
  // AEUDiscount
  items?: AEUDiscount[];
}

// Request arguments for CompleteInvoice.
export interface CancelInvoiceRequest {
  // ID of the invoice to mark as canceled.
  // string
  invoice_id?: string;
  
  // Human readable reason for this action
  // string
  reason?: string;
}

// Request arguments for commiting credit usage
export interface CommitCreditUsageRequest {
  // Identifier of the credit usage to be commited
  // string
  credit_usage_id?: string;
}

// Request arguments for CompleteInvoice.
export interface CompleteInvoiceRequest {
  // ID of the invoice to mark as completed.
  // string
  invoice_id?: string;
  
  // Human readable reason for this action
  // string
  reason?: string;
}

// Request arguments for CreatePaymentMethod.
export interface CreatePaymentMethodRequest {
  // Public create request
  // arangodb.cloud.billing.v1.CreatePaymentMethodRequest
  request?: arangodb_cloud_billing_v1_CreatePaymentMethodRequest;
  
  // User that made the original request
  // arangodb.cloud.iam.v1.User
  caller?: arangodb_cloud_iam_v1_User;
  
  // Billing configuration for the organization for which the request is made
  // arangodb.cloud.billing.v1.BillingConfig
  billing_config?: arangodb_cloud_billing_v1_BillingConfig;
  
  // Default currency to use for the organization
  // arangodb.cloud.currency.v1.Currency
  currency?: arangodb_cloud_currency_v1_Currency;
  
  // Tokens of the payment methods that already exist for this organization at this
  // payment provider (not deleted, same legal entity).
  // The tokens are opaque to the billing service; a provider uses them to reuse its
  // provider side objects instead of creating a new one for every payment method
  // (e.g. striped keeps a single Stripe customer holding all cards of an organization,
  // so that changing a card does not look like a new payment integration downstream).
  // Empty when the organization has no payment method at this provider yet.
  // string
  existing_payment_method_tokens?: string[];
}

// Request arguments for CreatePayment.
export interface CreatePaymentRequest {
  // Amount of money of the payment
  // number
  amount?: number;
  
  // Identifier of the currency of the payment.
  // string
  currency_id?: string;
  
  // Identifier of the payment provider that is used for this payment.
  // string
  payment_provider_id?: string;
  
  // Identifier of the payment method that is used for this payment.
  // string
  payment_method_id?: string;
  
  // Identifier of the invoice that the payment is for.
  // string
  invoice_id?: string;
  
  // Identifier of the legal entity that receives the payment.
  // string
  entity_id?: string;
  
  // Human readable description of the payment.
  // string
  description?: string;
  
  // Id of credit usage used to pay the payment if credit was used for payment.
  // string
  credit_usage_id?: string;
}

// Credit contains information about credit given to organization
export interface Credit {
  // Identifier of the Credit.
  // This is read only field
  // string
  id?: string;
  
  // Identifier of the Organization that owns the Credit
  // This field is required and can be set only while creating.
  // string
  organization_id?: string;
  
  // Timestamp when the credit was added to the system.
  // This is read only field
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Identifier of the user that added the Credit to the system.
  // This is read only field
  // string
  created_by_id?: string;
  
  // Identifier of credit currency.
  // string
  currency_id?: string;
  
  // Amount of the credit in credit currency.
  // Nore: This is total amount, not the available amount.
  // number
  amount?: number;
  
  // If true, all amount of this credit was used for payment.
  // This is read only field
  // boolean
  is_exhausted?: boolean;
  
  // When the Credit was exhausted
  // This is read only field.
  // googleTypes.Timestamp
  exhausted_at?: googleTypes.Timestamp;
}

// Creditist contains a list of Credits
export interface CreditList {
  // Credit Usage items
  // Credit
  items?: Credit[];
}

// CreditUsage contains information about Credit usage for invoice payment
export interface CreditUsage {
  // Identifier of the CreditUsage.
  // This is read only field.
  // string
  id?: string;
  
  // Identifier of related Credit.
  // This is read only field.
  // string
  credit_id?: string;
  
  // Identifier of related credit's Organization.
  // This is read only field.
  // string
  organization_id?: string;
  
  // When the CreditUsage was created.
  // This is read only field.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Identifier of the user that created the CreditUsage.
  // This is read only field.
  // string
  created_by_id?: string;
  
  // Amount of money that was spent.
  // This is read only field.
  // number
  amount?: number;
  
  // Identifier of the currency of amount that was spent.
  // This is read only field.
  // string
  currency_id?: string;
  
  // Amount of the related Credit currency that was deducted from Credit.
  // This is read only field.
  // number
  credit_currency_amount?: number;
  
  // Identifier of the invoice that CreditUsage was spent on.
  // This is read only field.
  // string
  invoice_id?: string;
  
  // If set CreditUsage was used to pay for invoice.
  // This is read only field.
  // boolean
  is_commited?: boolean;
  
  // When the CreditUsage was commited
  // This is read only field.
  // googleTypes.Timestamp
  commited_at?: googleTypes.Timestamp;
}

// CreditUsageList contains a list of Credit Usages
export interface CreditUsageList {
  // Credit Usage items
  // CreditUsage
  items?: CreditUsage[];
}

// Request arguments for setting credit as uncommited
export interface DiscardUncommitedCreditUsageRequest {
  // Identifier of the credit usage to be commited
  // string
  credit_usage_id?: string;
}

// EverestCustomer maps an ArangoDB organization to its Everest customer record.
export interface EverestCustomer {
  // Identifier of the ArangoDB organization (primary key).
  // string
  organization_id?: string;
  
  // UUID of the Everest customer record.
  // string
  everest_customer_uuid?: string;
  
  // Timestamp of first creation.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Timestamp of last upsert.
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // Hash of the customer data last pushed to Everest. Used by everestd to skip
  // re-upserting an unchanged customer during the periodic reconcile.
  // string
  last_synced_hash?: string;
}

// List of EverestCustomer records.
export interface EverestCustomerList {
  // EverestCustomer
  items?: EverestCustomer[];
}

// EverestInvoice is a locally stored snapshot of an invoice generated by
// Everest (Billing 2.0). Synced periodically by everestd; Everest remains the
// source of truth.
export interface EverestInvoice {
  // UUID of the invoice in Everest (primary key).
  // string
  invoice_uuid?: string;
  
  // Identifier of the ArangoDB organization (denormalized).
  // string
  organization_id?: string;
  
  // Human readable invoice number.
  // string
  invoice_number?: string;
  
  // Issue date (midnight UTC of the invoice day).
  // googleTypes.Timestamp
  invoice_date?: googleTypes.Timestamp;
  
  // Payment due date (midnight UTC of the due day). The invoice becomes
  // overdue at the end of the due day (due_date + 24h).
  // googleTypes.Timestamp
  due_date?: googleTypes.Timestamp;
  
  // Tier of the organization as of the last sync (denormalized from the
  // resource manager; refreshed on every sync, so it reflects the current
  // tier rather than the tier at invoice time).
  // string
  organization_tier_id?: string;
  
  // Identifier of the legal entity the organization has a contract with, as
  // of the last sync (denormalized; refreshed on every sync).
  // string
  entity_id?: string;
  
  // Gross total including tax.
  // EverestInvoiceAmount
  total_amount?: EverestInvoiceAmount;
  
  // Outstanding balance (total - payments - credits).
  // EverestInvoiceAmount
  total_amount_due?: EverestInvoiceAmount;
  
  // Sum of payments applied.
  // EverestInvoiceAmount
  payments_applied?: EverestInvoiceAmount;
  
  // Sum of credit notes applied.
  // EverestInvoiceAmount
  total_credited?: EverestInvoiceAmount;
  
  // Total tax.
  // EverestInvoiceAmount
  total_tax?: EverestInvoiceAmount;
  
  // Settlement state derived from the amounts at sync time.
  // EverestInvoicePaymentState
  payment_state?: EverestInvoicePaymentState;
  
  // Set when the invoice is not fully settled (payment_state other than
  // PAID_IN_FULL / CREDITED_IN_FULL) and the due day has passed.
  // Computed at read time by billingd; never stored.
  // boolean
  is_overdue?: boolean;
  
  // Addresses as carried on the invoice.
  // EverestInvoiceAddress
  bill_to_address?: EverestInvoiceAddress;
  
  // EverestInvoiceAddress
  sold_to_address?: EverestInvoiceAddress;
  
  // Timestamp of first creation of this snapshot.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Timestamp of last upsert.
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // Time of the last successful sync from Everest.
  // googleTypes.Timestamp
  last_synced_at?: googleTypes.Timestamp;
}

// EverestInvoiceAddress is a postal address as carried on an Everest invoice.
export interface EverestInvoiceAddress {
  // First address line.
  // string
  line1?: string;
  
  // Second address line.
  // string
  line2?: string;
  
  // Attention / addressee line.
  // string
  attention?: string;
  
  // City name.
  // string
  city?: string;
  
  // State or province name.
  // string
  state_province?: string;
  
  // Country name or code.
  // string
  country?: string;
  
  // ZIP / postal code.
  // string
  zip_code?: string;
}

// EverestInvoiceAmount is a currency-tagged decimal amount exactly as returned
// by Everest (kept as a string to avoid precision loss).
export interface EverestInvoiceAmount {
  // Decimal amount, e.g. "1234.56".
  // string
  amount?: string;
  
  // ISO currency code, e.g. "USD".
  // string
  currency?: string;
}

// List of EverestInvoice snapshots.
export interface EverestInvoiceList {
  // EverestInvoice
  items?: EverestInvoice[];
}

// Aggregated statistics over a set of EverestInvoice snapshots.
export interface EverestInvoiceStatistics {
  // Total number of invoices matching the filter.
  // number
  total_invoices?: number;
  
  // Count in payment_state UNPAID.
  // number
  unpaid_invoices?: number;
  
  // Count in payment_state PARTIALLY_PAID.
  // number
  partially_paid_invoices?: number;
  
  // Count in payment_state PAID_IN_FULL.
  // number
  paid_invoices?: number;
  
  // Count in payment_state CREDITED_IN_FULL.
  // number
  credited_invoices?: number;
  
  // Count of open invoices whose due day has fully passed
  // (matches EverestInvoiceIsOverdue).
  // number
  overdue_invoices?: number;
  
  // Summed amounts, one entry per distinct currency.
  // EverestInvoiceStatisticsCurrencyValue
  currency_values?: EverestInvoiceStatisticsCurrencyValue[];
}

// Summed invoice amounts for a single currency.
export interface EverestInvoiceStatisticsCurrencyValue {
  // ISO currency code these sums are in.
  // string
  currency?: string;
  
  // Sum of total_amount across the matching invoices in this currency.
  // EverestInvoiceAmount
  total_amount?: EverestInvoiceAmount;
  
  // Sum of total_amount_due across the matching invoices in this currency.
  // EverestInvoiceAmount
  total_amount_due?: EverestInvoiceAmount;
}

// EverestSalesOrder maps an ArangoDB resource to its Everest sales order.
// The anchored resource is either a deployment (deployment_id set) or a
// data cluster (datacluster_id set, for dedicated data cluster billing);
// exactly one of the two must be set. The anchor id equals the Everest
// externalSubscriptionId of the sales order's subscription.
export interface EverestSalesOrder {
  // Identifier of the ArangoDB deployment (primary key when set).
  // Empty for data-cluster sales orders.
  // string
  deployment_id?: string;
  
  // Identifier of the ArangoDB organization (denormalized).
  // string
  organization_id?: string;
  
  // UUID of the Everest sales order record.
  // string
  sales_order_uuid?: string;
  
  // UUID of the Everest customer this sales order belongs to.
  // string
  everest_customer_uuid?: string;
  
  // Timestamp of first creation.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Timestamp of last upsert.
  // googleTypes.Timestamp
  updated_at?: googleTypes.Timestamp;
  
  // Identifier of the ArangoDB data cluster (primary key when set).
  // Set for dedicated data cluster sales orders only; empty for deployment
  // sales orders.
  // string
  datacluster_id?: string;
}

// List of EverestSalesOrder records.
export interface EverestSalesOrderList {
  // EverestSalesOrder
  items?: EverestSalesOrder[];
}

// Request for GetEffectiveAEUDiscount.
export interface GetEffectiveAEUDiscountRequest {
  // Identifier of the organization.
  // This is a required field.
  // string
  organization_id?: string;
  
  // Point in time to get the effective entry for.
  // This is a required field.
  // googleTypes.Timestamp
  at?: googleTypes.Timestamp;
}

// Request arguments for GetLastInvoice.
export interface GetLastInvoiceRequest {
  // Identifier of the organization to get the last invoice for.
  // string
  organization_id?: string;
}

// Invoice info is used to store additional Invoice information for internal use
export interface InvoiceInfo {
  // Public part of Invoice.
  // arangodb.cloud.billing.v1.Invoice
  invoice?: arangodb_cloud_billing_v1_Invoice;
  
  // Set if all payments failed for this invoice and is not expected to be paid.
  // boolean
  non_collectible?: boolean;
  
  // The timestamp when the invoice was canceled at
  // googleTypes.Timestamp
  canceled_at?: googleTypes.Timestamp;
  
  // If set, the invoice was canceled.
  // boolean
  is_canceled?: boolean;
  
  // Human readable reason of cancelation.
  // string
  cancelation_reason?: string;
  
  // Tier this organization belongs to during the creation of the invoice.
  // string
  organization_tier_id?: string;
  
  // The timestamp of the usage-item with the earliest starts_at of the entire invoice.
  // googleTypes.Timestamp
  usage_items_from?: googleTypes.Timestamp;
  
  // The timestamp of the usage-item with the latest ends_at of the entire invoice.
  // googleTypes.Timestamp
  usage_items_to?: googleTypes.Timestamp;
}

// InvoiceInfoList holds a list of InvoiceInfos
export interface InvoiceInfoList {
  // Actual InvoiceInfos
  // InvoiceInfo
  items?: InvoiceInfo[];
}

// InvoiceStatistics contains statistics for invoices that match a given filter.
// All amounts are given in the base currency.
export interface InvoiceStatistics {
  // Number of invoices that passed the filter.
  // number
  total_invoices?: number;
  
  // Number of invoices in pending state.
  // number
  pending_invoices?: number;
  
  // Number of invoices in completed state.
  // number
  completed_invoices?: number;
  
  // Number of invoices in rejected state.
  // number
  rejected_invoices?: number;
  
  // Number of invoices that have been verified.
  // number
  verified_invoices?: number;
  
  // Invoice values grouped by currency
  // InvoiceStatistics_CurrencyValue
  currency_values?: InvoiceStatistics_CurrencyValue[];
}

// Invoices summary values in given currency
export interface InvoiceStatistics_CurrencyValue {
  // Currency of the invoices
  // string
  currency_id?: string;
  
  // Total value of invoices that passed the filter (excluding taxes).
  // number
  total_value?: number;
  
  // Total value of invoices that passed the filter (including taxes).
  // number
  total_value_including_taxes?: number;
  
  // Total value of pending invoices (excluding taxes).
  // number
  pending_value?: number;
  
  // Total value of completed invoices (excluding taxes).
  // number
  completed_value?: number;
  
  // Total value of rejected invoices (excluding taxes).
  // number
  rejected_value?: number;
  
  // Total value of invoices that are non_collectible and that passed the filter (excluding taxes).
  // number
  total_non_collectible_value?: number;
}

// Request for ListAEUDiscounts.
export interface ListAEUDiscountsRequest {
  // Identifier of the organization to list the discount history of.
  // This is a required field.
  // string
  organization_id?: string;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
}

// Request for ListAllEverestInvoices.
export interface ListAllEverestInvoicesRequest {
  // If set, return only invoices of the specified organization.
  // This is an optional field.
  // string
  organization_id?: string;
  
  // If set, return only invoices that are not fully settled
  // (payment_state not in PAID_IN_FULL / CREDITED_IN_FULL).
  // This is an optional field.
  // boolean
  open_only?: boolean;
  
  // If set, return only invoices with invoice_date >= this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  invoice_date_from?: googleTypes.Timestamp;
  
  // If set, return only invoices with invoice_date <= this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  invoice_date_to?: googleTypes.Timestamp;
  
  // If set, return only invoices whose invoice number contains this string
  // (case-insensitive substring match).
  // This is an optional field.
  // string
  invoice_number?: string;
  
  // If set, return only invoices whose organization currently has this tier
  // (matches EverestInvoice.organization_tier_id).
  // This is an optional field.
  // string
  organization_tier_id?: string;
  
  // If set, return only invoices whose organization currently belongs to
  // this legal entity (matches EverestInvoice.entity_id).
  // This is an optional field.
  // string
  entity_id?: string;
  
  // If set, return only overdue invoices: not fully settled, with a due date
  // whose due day has fully passed (see EverestInvoice.is_overdue).
  // This is an optional field.
  // boolean
  overdue_only?: boolean;
  
  // If set (not UNSPECIFIED), return only invoices in this payment state.
  // This is an optional field.
  // EverestInvoicePaymentState
  payment_state?: EverestInvoicePaymentState;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
}

// Request arguments for ListAllInvoices
export interface ListAllInvoicesRequest {
  // Request invoices for the organization with this id.
  // This is an optional field.
  // string
  organization_id?: string;
  
  // Request invoices that are created at or after this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  from?: googleTypes.Timestamp;
  
  // Request invoices that are created before this timestamp.
  // This is an optional field.
  // googleTypes.Timestamp
  to?: googleTypes.Timestamp;
  
  // If set, only pending invoices are returned
  // This is an optional field.
  // boolean
  pending_only?: boolean;
  
  // If set, only completed invoices are returned
  // This is an optional field.
  // boolean
  completed_only?: boolean;
  
  // If set, only rejected invoices are returned
  // This is an optional field.
  // boolean
  rejected_only?: boolean;
  
  // If set, only invoices that needs to be rebuild are returned
  // This is an optional field.
  // boolean
  needs_rebuild_only?: boolean;
  
  // If set, only invoices that do not need to be verified, or needs verification and are verified are returned
  // This is an optional field.
  // boolean
  verified_only?: boolean;
  
  // Request all invoices with type either 'Regular' or 'PurchaseOrder'
  // This is an optional field.
  // string
  type?: string;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // If set, only invoices that have non_collectible set to true are returned
  // This is an optional field.
  // boolean
  non_collectible_only?: boolean;
  
  // If set, only invoices that have non_collectible set to false are returned
  // This is an optional field.
  // boolean
  collectible_only?: boolean;
  
  // If set, only invoices that need to be verified are returned
  // This is an optional field.
  // boolean
  non_verified_only?: boolean;
  
  // Whether or not to include the usage item IDs on every Invoice_Item in the returned Invoices.
  // This is an optional field; usage item IDs are not included by default.
  // boolean
  include_usageitem_ids?: boolean;
  
  // If set, only invoices that were canceled are returned
  // boolean
  canceled_only?: boolean;
  
  // If set, only invoices that were not canceled are returned
  // boolean
  not_canceled_only?: boolean;
  
  // If set, only invoices for given entity ID will be returned
  // This is an optional field.
  // string
  entity_id?: string;
  
  // If set, only invoices with the given (partly) number will be returned
  // This is an optional field.
  // string
  invoice_number?: string;
  
  // If set, only invoices of organizations that had this tier at invoice
  // creation time (see InvoiceInfo.organization_tier_id) are returned.
  // This is an optional field.
  // string
  organization_tier_id?: string;
}
export interface ListCreditRequest {
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // If set return only credits for organization with given id
  // string
  organization_id?: string;
  
  // If set return only credits with given currency
  // string
  currency_id?: string;
  
  // If set return only credits created by user with given id
  // string
  created_by_id?: string;
  
  // If set return only credits created before given timestamp
  // googleTypes.Timestamp
  created_before?: googleTypes.Timestamp;
  
  // If set return only credits created after given timestamp
  // googleTypes.Timestamp
  created_after?: googleTypes.Timestamp;
  
  // If set to true return only credits that are exhausted
  // boolean
  exhausted_only?: boolean;
  
  // If set to true return only credits that are not exhausted
  // boolean
  not_exhausted_only?: boolean;
}
export interface ListCreditUsageRequest {
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
  
  // If set return only usages associated with given credit
  // string
  credit_id?: string;
  
  // If set return only usages associated with given credit
  // string
  invoice_id?: string;
  
  // If set return only usages with given currency
  // string
  currency_id?: string;
  
  // If set return only usages created by user with given id
  // string
  created_by_id?: string;
  
  // If set return only usages created before given timestamp
  // googleTypes.Timestamp
  created_before?: googleTypes.Timestamp;
  
  // If set return only usages created after given timestamp
  // googleTypes.Timestamp
  created_after?: googleTypes.Timestamp;
  
  // If set to true return only credits that are commited
  // boolean
  commited_only?: boolean;
  
  // If set to true return only credits that are not commited
  // boolean
  not_commited_only?: boolean;
  
  // If set return only usages for given organization_id
  // string
  organization_id?: string;
}

// Request for ListEverestCustomers.
export interface ListEverestCustomersRequest {
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
}

// Request for ListEverestSalesOrders.
export interface ListEverestSalesOrdersRequest {
  // If set, return only sales orders for the specified organization.
  // This is an optional field.
  // string
  organization_id?: string;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
}

// Request for listing payments.
export interface ListPaymentsRequest {
  // If set, return payments for the specified invoice.
  // string
  invoice_id?: string;
  
  // Standard list options
  // This is an optional field.
  // arangodb.cloud.common.v1.ListOptions
  options?: arangodb_cloud_common_v1_ListOptions;
}
export interface PDFDocument {
  // Content of the document
  // string
  content?: string;
  
  // Filename of the document
  // string
  filename?: string;
}

// Payment represents a transfer of money from a customers using once
// of the customers payment methods into the merchant account of the legal entity.
export interface Payment {
  // Unique identifier of this payment.
  // This is a read-only field.
  // string
  id?: string;
  
  // Identifier of this payment (created by payment provider)
  // string
  payment_id?: string;
  
  // Amount of money of the payment
  // number
  amount?: number;
  
  // Identifier of the currency of the payment.
  // string
  currency_id?: string;
  
  // Identifier of the payment provider that is used for this payment.
  // string
  payment_provider_id?: string;
  
  // Identifier of the payment method that is used for this payment.
  // string
  payment_method_id?: string;
  
  // Identifier of the invoice that the payment is for.
  // string
  invoice_id?: string;
  
  // Identifier of the legal entity that receives the payment.
  // string
  entity_id?: string;
  
  // Human readable description of the payment.
  // string
  description?: string;
  
  // The timestamp of creation of the payment.
  // googleTypes.Timestamp
  created_at?: googleTypes.Timestamp;
  
  // Payment_Status
  status?: Payment_Status;
}

// Status of the payment
export interface Payment_Status {
  // If set, this payment is still being processed.
  // If set, is_completed & is_rejected must be false.
  // boolean
  is_pending?: boolean;
  
  // If set, this payment has been payed for succesfully.
  // If set, is_pending & is_rejected must be false.
  // boolean
  is_completed?: boolean;
  
  // If set, this payment has been rejected.
  // If set, is_pending & is_completed must be false.
  // boolean
  is_rejected?: boolean;
  
  // The timestamp of succesfull completion of the payment.
  // googleTypes.Timestamp
  completed_at?: googleTypes.Timestamp;
  
  // The timestamp of rejected completion of the payment.
  // googleTypes.Timestamp
  rejected_at?: googleTypes.Timestamp;
  
  // Human readable reason for the rejection.
  // string
  rejection_reason?: string;
}

// List of payments.
export interface PaymentList {
  // Payment
  items?: Payment[];
}

// Request arguments for CreatePayment.
export interface ProviderCreatePaymentRequest {
  // Amount of money of the payment
  // number
  amount?: number;
  
  // Currency to use for the payment
  // arangodb.cloud.currency.v1.Currency
  currency?: arangodb_cloud_currency_v1_Currency;
  
  // Identifier of the payment provider that is used for this payment.
  // string
  payment_provider_id?: string;
  
  // Payment method that is used for this payment.
  // arangodb.cloud.billing.v1.PaymentMethod
  payment_method?: arangodb_cloud_billing_v1_PaymentMethod;
  
  // Invoice that the payment is for.
  // arangodb.cloud.billing.v1.Invoice
  invoice?: arangodb_cloud_billing_v1_Invoice;
  
  // Legal entity that receives the payment.
  // arangodb.cloud.internal.resourcemanager.v1.EntityDetails
  entity?: arangodb_cloud_internal_resourcemanager_v1_EntityDetails;
  
  // Human readable description of the payment.
  // string
  description?: string;
  
  // Id of credit usage used to pay the payment if credit was used for payment.
  // string
  credit_usage_id?: string;
}

// Request arguments for setting credit as exhausted
export interface SetCreditExhaustedRequest {
  // identifier of the credit to be set as exhausted
  // string
  credit_id?: string;
}

// SetInvoiceNonCollectibleRequest is used to update InvoiceInfo non_collectible flag
export interface SetInvoiceNonCollectibleRequest {
  // Identifier of the invoice
  // string
  invoice_id?: string;
  
  // Value to be set on non_collectible field
  // boolean
  non_collectible?: boolean;
}

// Request arguments for SetOrganizationExcludedFromBilling.
export interface SetOrganizationExcludedFromBillingRequest {
  // ID of the organization to configure
  // string
  organization_id?: string;
  
  // Set to exclude organization from billing.
  // boolean
  excluded?: boolean;
}

// Request arguments for SetOrganizationUsesPurchaseOrders
export interface SetOrganizationUsesPurchaseOrdersRequest {
  // ID of the organization to configure
  // string
  organization_id?: string;
  
  // Set to use purchase orders for this organization.
  // boolean
  uses_purchase_order?: boolean;
}

// Request arguments for using credit
export interface UseCreditRequest {
  // Identifier of the organization
  // string
  organization_id?: string;
  
  // Amount of money that was spent.
  // number
  amount?: number;
  
  // Identifier of the currency of amount that was spent.
  // string
  currency_id?: string;
  
  // Identifier of the invoice that CreditUsage was spent on.
  // string
  invoice_id?: string;
}

// EverestInvoicePaymentState describes how far an Everest invoice is settled.
// Derived by everestd from the invoice amounts at sync time. Everest itself
// returns no status field; these values mirror Everest's list-filter statuses
// (unpaid / partiallyPaid / paidInFull / creditedInFull). "Overdue" is
// deliberately NOT a stored state — it is computed at read time from due_date.
export enum EverestInvoicePaymentState {
  // Not set.
  EVEREST_INVOICE_PAYMENT_STATE_UNSPECIFIED = 0,
  
  // No payments or credits applied yet.
  EVEREST_INVOICE_PAYMENT_STATE_UNPAID = 1,
  
  // Some payments or credits applied, but an amount is still due.
  EVEREST_INVOICE_PAYMENT_STATE_PARTIALLY_PAID = 2,
  
  // Fully settled by payments.
  EVEREST_INVOICE_PAYMENT_STATE_PAID_IN_FULL = 3,
  
  // Fully settled by credit notes.
  EVEREST_INVOICE_PAYMENT_STATE_CREDITED_IN_FULL = 4,
}

// InternalBillingService is the API used to create & update invoices.
// This service identifies itself as APIIDBilling.
export interface IInternalBillingService {
}

// InternalBillingService is the API used to create & update invoices.
// This service identifies itself as APIIDBilling.
export class InternalBillingService implements IInternalBillingService {
}

// InternalPDFService is the API implemented by the invoice PDF builder.
// This service identifies itself as APIIDPDF.
export interface IInternalPDFService {
}

// InternalPDFService is the API implemented by the invoice PDF builder.
// This service identifies itself as APIIDPDF.
export class InternalPDFService implements IInternalPDFService {
}

// InternalPaymentProviderService is the API implemented by specific payment providers.
// This service identifies itself as APIIDPaymentProvider.
export interface IInternalPaymentProviderService {
}

// InternalPaymentProviderService is the API implemented by specific payment providers.
// This service identifies itself as APIIDPaymentProvider.
export class InternalPaymentProviderService implements IInternalPaymentProviderService {
}
